import React, { useEffect, useState } from 'react';
import 'react-circular-progressbar/dist/styles.css';
import '../QuizAssessment.scss';
import AppLink from '../../../../../components/AppLink';
import TabItem from './TabItem';

const Tabs = ({ isWidget, tabs, setActiveTab, activeTab }) => {
  if (!Object.entries(tabs).length) return null;

  const totals = Object.entries(tabs?.stats).reduce(
    (acc, curr) => {
      const data = curr[1]
      return {
        count: acc.count + data.totalCount || 0,
        completed: acc.completed + data.completed || 0,
        correct: acc.correct + data.correct || 0,
      }
    },
    { count: 0, completed: 0, correct: 0 },
  )
  totals.percentage = Math.round((totals.correct / totals.completed) * 100) || 0

  const ClickHandler = ({ to, subcategoryName, children }) => {
    if (isWidget)
      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => setActiveTab(subcategoryName)}
        >
          {children}
        </div>
      )
    return <AppLink to={to}>{children}</AppLink>
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
      }}
    >
      {Object.entries(tabs?.stats).map(([subcategoryName, subcategoryData]) => {
        const { completed, correct, link, totalCount } = subcategoryData

        const percentage = Math.round((correct / completed) * 100) || 0
        return (
          <div key={subcategoryName} className="QuizAssessment__slider-item">
            <ClickHandler to={link} subcategoryName={subcategoryName}>
              <TabItem
                completed={completed}
                percentage={percentage}
                correct={correct}
                subcategoryName={subcategoryName}
                totalCount={totalCount}
                isActive={activeTab === subcategoryName}
              />
            </ClickHandler>
          </div>
        )
      })}
      <div className="QuizAssessment__slider-item">
        <TabItem
          subcategoryName="totals"
          totalCount={totals.count}
          completed={totals.completed}
          percentage={totals.percentage}
          correct={totals.correct}
        />
      </div>
    </div>
  )
}

export default Tabs;
